import { Add as AddIcon } from '@material-ui/icons';
import { TabletButton } from '@campfire/tablet-button';
import { formatDistance, unpackToDateTime } from '@campfire/hot-date';
import React, { useState } from 'react';
import { LeftMenuItemType } from '../../incoming-volunteer-model.gql';
import { GetIncomingVolunteerProfile_vm_profile_application_applicationActivities as ApplicationActivities } from '../../__generated__/GetIncomingVolunteerProfile';
import { TaskPendingReviewIcon } from '../../../../../../common/icons/TaskPendingReviewIcon';
import { TaskCompleteIcon } from '../../../../../../common/icons/TaskCompleteIcon';
import { TaskRejectedIcon } from '../../../../../../common/icons/TaskRejectedIcon';
import { AddActivityApplicationDialog } from './AddActivityApplicationDialog';
import { IncomingVolunteerTaskList } from '../IncomingVolunteerTaskList';

interface Props {
  setLeftMenuItem: (x: LeftMenuItemType) => void;
  applicationActivities?: ApplicationActivities[];
  applicationAvailabilitySimple: boolean;
  selectedApplicationActivityId?: string;
  availabilitySelected?: boolean;
  userId?: string;
  refetch?: () => void;
}

const approvedStatuses = ['to-team', 'to-application', 'to-waitlist'];

const statusText = (status: string) =>
  status === 'pending'
    ? 'Pending review'
    : status === 'to-team'
    ? 'Added to team'
    : status === 'to-application'
    ? 'Added as applicant'
    : status === 'to-waitlist'
    ? 'Added to waitlist'
    : 'Rejected';

const IncomingVolunteerActivitiesSection = (props: Props) => {
  const {
    setLeftMenuItem,
    applicationActivities,
    applicationAvailabilitySimple,
    selectedApplicationActivityId,
    availabilitySelected,
    userId,
    refetch,
  } = props;
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const existingActivityIds = (applicationActivities ?? []).map((a) => a.activity.activityId);

  const activityItems = (applicationActivities ?? []).map((activity) => ({
    taskId: activity.applicationActivityId,
    icon:
      activity.status === 'pending' ? (
        <TaskPendingReviewIcon />
      ) : approvedStatuses.includes(activity.status) ? (
        <TaskCompleteIcon isComplete />
      ) : (
        <TaskRejectedIcon />
      ),
    taskTitle: activity.activity.name,
    taskSubText: statusText(activity.status),
    taskRecentActivityStatus: activity.dateActioned
      ? `Updated ${formatDistance(unpackToDateTime(activity.dateActioned))}`
      : 'Not reviewed',
    selected: activity.applicationActivityId === selectedApplicationActivityId,
    adminOnly: false,
    onClick: () =>
      setLeftMenuItem({
        applicationActivityId: activity.applicationActivityId,
        type: 'VOLUNTEER_ApplicationActivityType',
      }),
  }));

  const availabilityItems = applicationAvailabilitySimple
    ? [
        {
          taskId: 'simple-availability',
          icon: <TaskCompleteIcon isComplete />,
          taskTitle: 'Availability (Simple)',
          selected: availabilitySelected,
          adminOnly: false,
          onClick: () => setLeftMenuItem({ type: 'VOLUNTEER_SimpleAvailabilityType' }),
        },
      ]
    : [];

  return (
    <>
      {userId && refetch && (
        <AddActivityApplicationDialog
          open={addDialogOpen}
          onClose={() => setAddDialogOpen(false)}
          userId={userId}
          existingActivityIds={existingActivityIds}
          onSuccess={refetch}
        />
      )}
      <IncomingVolunteerTaskList
        header='Activities & Availabilities'
        headerAction={
          userId && refetch ? (
            <TabletButton
              variant='text'
              color='primary'
              size='small'
              startIcon={<AddIcon />}
              onClick={() => setAddDialogOpen(true)}
            >
              Add
            </TabletButton>
          ) : (
            undefined
          )
        }
        items={[...activityItems, ...availabilityItems]}
      />
    </>
  );
};

export { IncomingVolunteerActivitiesSection };
